import {Component, EventEmitter, Output, ViewChild} from '@angular/core';

import {CaseVehicle} from '../case-vehicle';
import {CaseVehicleService} from '../case-vehicle.service';

@Component({
  selector: 'app-case-vehicle-edit',
  templateUrl: 'edit.component.html',
})
export class CaseVehicleEditComponent {
  @ViewChild('staticModal') staticModal;

  @Output() completed = new EventEmitter<boolean>();

  public disabled: boolean = false;

  public model: CaseVehicle;

  private givenCaseId: string;

  constructor(private readonly caseVehicleService: CaseVehicleService) {}

  public get caseId(): string {
    return this.givenCaseId;
  }

  public open(caseId: string, model: CaseVehicle): void {
    this.givenCaseId = caseId;
    this.model = model;
    this.staticModal.show();
  }

  public close() {
    this.workCompleted();
  }

  public confirmEdit($event) {
    $event.preventDefault();
    this.disabled = true;
    this.caseVehicleService
      .updateCaseVehicle(this.model.id, this.model, {
        parameters: { id: this.caseId },
      })
      .subscribe(() => {
        this.workCompleted();
      });
  }

  private workCompleted() {
    this.model = undefined;
    this.disabled = false;
    this.staticModal.hide();
    this.completed.next(true);
  }
}
